<template>
  <Tab @close="removeCurrent">
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #toolbar-items>
      <!-- Tracking des invitations ------------------------ -->
      <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'tracking'"
          icon="fa-chart-line"
          name="tracking"
      ></TabToolbarButton>
      <!-- Création des invitations -->
      <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'emailing'"
          icon="fa-envelope"
          name="emailing"
      ></TabToolbarButton>
      <!-- Création des invitations Removed 29/10/22  -->
      <TabToolbarButton v-if="false"
          v-model="page"
          :menu="menu"
          :selected="page === 'csv'"
          icon="fa-envelope"
          name="csv"
      ></TabToolbarButton>
      <!-- Identification des emails clients Removed 29/10/22 -->
      <TabToolbarButton v-if="false"
          v-model="page"
          :menu="menu"
          :selected="page === 'manual'"
          icon="fa-search"
          name="manual"
      ></TabToolbarButton>
    </template>
    <template #container>
      <v-snackbar v-model="snackbar"
          :color="snackbarColor"
          :timeout="snackbarTimeout"
          :multi-line="true"
          text
          outlined
          tile
          app
          top
      >
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn icon @click="snackbar = false" style="position: absolute;right: 3px;bottom: 13px;">
            <v-icon :color="snackbarColor" small>fa-times</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <!-- Liste des invitations -->
      <TabPage :menu="menu" :page="page" name="tracking" documentation-path="manager/invitation/suivi">
        <template #content>
          <v-dialog
              v-if="solicitation"
              v-model="solicitationDialog"
              max-width="80%"
              @click:outside="closeSolicitationDialog"
          >
            <v-card>
              <v-card-title>
                <span class="sr-title">{{ $t("invitation.tracking.title") }} N° {{ solicitation.id }}</span>
              </v-card-title>
              <v-card-text>
                <solicitation-view :solicitation="solicitation"></solicitation-view>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="!solicitation.is_canceled" small @click="cancelSolicitation(solicitation)"
                >{{ $t("invitation.tracking.cancel") }}
                </v-btn>
                <v-btn small @click="deleteSolicitation(solicitation)"
                >{{ $t("invitation.tracking.delete") }}
                </v-btn>
                <v-btn :disabled="solicitation.need_revalidate===1" small @click="confirmSolicitation(solicitation,'D')">{{ $t("invitation.tracking.confirm_domain") }}</v-btn>
                <v-btn :disabled="solicitation.need_revalidate===1" small @click="confirmSolicitation(solicitation,'P')">{{ $t("invitation.tracking.confirm_product") }}</v-btn>
                <v-btn :disabled="solicitation.need_revalidate===1" small @click="confirmSolicitation(solicitation,'T')">{{ $t("invitation.tracking.confirm_thematic") }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn style="float: right;" color="primary" small @click="closeSolicitationDialog"
                >{{ $t("invitation.tracking.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-row>
            <v-col cols="12">
              <WebsiteWrapper @selected="WebsiteWrapperChange" :verified="2" :plan="1" mandatory>
                <v-card>
                  <v-container>
                    <span class="sr-title">
                      <!-- List tit le -->
                      {{ $t("invitation.tracking.title") }}
                    </span>
                    <div class="float-right" style="position:relative; top:-5px;">
                      <v-btn :title="$t('stories.manager.list.reload')" color="primary" icon
                             @click="fetchSolicitations()">
                        <v-icon small>fas fa-sync-alt</v-icon>
                      </v-btn>
                    </div>
                  </v-container>
                  <v-card-text>
                    <div v-if="solicitations_pagination.hasOwnProperty('counters')&&(solicitations_pagination.counters.length > 0)">
                      <div class="sr-title">{{ $t("invitation.tracking.list.infos.title") }}</div>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <template v-for="counters in solicitations_pagination.counters">
                              <th
                                  v-for="counter in counters"
                                  :key="counter.month + '' + counter.year"
                                  class="text-left"
                              >
                                {{ $t("invitation.tracking.list.infos." + counter.month) }} {{ counter.year }}
                              </th>
                            </template>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <template v-for="counters in solicitations_pagination.counters">
                              <td v-for="counter in counters" :key="counter.month + '' + counter.year">
                                <div>
                                  <strong>{{ $t("invitation.tracking.list.infos.total") }}:</strong>
                                  {{ counter.total_count }}
                                </div>
                                <div>
                                  <strong>{{ $t("invitation.tracking.list.infos.not_pending") }}:</strong>
                                  {{ counter.total_count - counter.pending_count }}
                                </div>
                                <div>
                                  <strong>{{ $t("invitation.tracking.list.infos.percentage") }}:</strong>
                                  {{
                                    Math.ceil(
                                        ((counter.total_count - counter.pending_count) / counter.total_count) * 100
                                    ).toFixed(0)
                                  }}%
                                </div>
                              </td>
                            </template>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </div>
                    <div class="mt-4">
                      <div class="sr-title">{{ $t("invitation.tracking.list.title") }}</div>
                      <v-card>
                        <v-card-text>
                          <v-row align="center">
                            <v-col>
                              <FormField
                                  v-model="keywords"
                                  :props="{ maxLength: 255 }"
                                  i18n="invitation.tracking.list.keywords"
                                  input-type="text"
                              />
                            </v-col>
                            <v-col>
                              <v-btn class="mr-6" color="primary" small @click="fetchSolicitations()">
                                {{ $t("common.update") }}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">
                                {{ $t("invitation.tracking.table.client") }}
                              </th>
                              <th class="text-left">
                                {{ $t("invitation.tracking.table.profile") }}
                              </th>
                              <th class="text-left">
                                {{ $t("invitation.tracking.table.created_at") }}
                              </th>
                              <th class="text-center">
                                {{ $t("invitation.tracking.table.mail_send") }}
                              </th>
                              <th class="text-center">
                                {{ $t("invitation.tracking.table.mail_clicked") }}
                              </th>
                              <th class="text-center">
                                {{ $t("invitation.tracking.table.token_used") }}
                              </th>
                              <th class="text-center">
                                {{ $t("invitation.tracking.table.publication_moderated") }}
                              </th>
                              <th class="text-center">
                                {{ $t("invitation.tracking.table.need_revalidate") }}
                              </th>
                              <th class="text-center">
                                {{ $t("invitation.tracking.table.is_revalidated") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="solicitation in solicitations"
                              :key="solicitation.id"
                              :title="$t('invitation.tracking.row')"
                              class="tw-cursor-pointer"
                              @click="selectSolicitation(solicitation)"
                            >
                              <td>
                                <div v-if="solicitation.first_name || solicitation.last_name" class="font-weight-bold">
                                  {{ solicitation.first_name }} {{ solicitation.last_name }}
                                </div>
                                <div v-if="solicitation.email">
                                  {{ solicitation.email }}
                                </div>
                              </td>
                              <td>
                                <span v-if="solicitation.name">{{ solicitation.name }}</span>
                                <span v-else>Admin</span>
                              </td>
                              <td v-if="solicitation.is_canceled">
                                <span style="text-decoration: line-through;">{{ solicitation.created_at | moment("DD/MM/YYYY HH:mm") }}</span><br>
                                <i>{{$t('invitation.tracking.canceled_at')}}</i><br>
                                <span style="color:orange;">{{ solicitation.canceled_at | moment("DD/MM/YYYY HH:mm") }}</span>
                              </td>
                              <td v-else>
                                {{ solicitation.created_at | moment("DD/MM/YYYY HH:mm") }}
                              </td>
                              <td :title="solicitation.mail_send_at ? solicitation.mail_send_at : '-'"
                                  class="text-center flex flex"
                              >
                                <v-icon
                                    v-if="solicitation.is_mail_send === 0 && solicitation.is_mail_clicked === 1"
                                    color="primary"
                                    small
                                >
                                  fa-minus
                                </v-icon>
                                <v-icon v-else-if="solicitation.is_mail_send === 1" color="success" small>
                                  fa-check
                                </v-icon>
                                <v-icon v-else color="error" small>
                                  fa-times
                                </v-icon>
                                <div v-if="solicitation.mail_send_at">
                                  {{ solicitation.mail_send_at | moment("DD/MM/YYYY") }}
                                </div>
                              </td>
                              <td :title="solicitation.mail_clicked_at ? solicitation.mail_clicked_at : '-'"
                                  class="text-center flex"
                              >
                                <v-icon v-if="solicitation.is_mail_clicked === 1" color="success" small>
                                  fa-check
                                </v-icon>
                                <v-icon v-else color="error" small>
                                  fa-times
                                </v-icon>
                                <div v-if="solicitation.mail_clicked_at">
                                  {{ solicitation.mail_clicked_at | moment("DD/MM/YYYY") }}
                                </div>
                              </td>
                              <td :title="solicitation.token_used_at ? solicitation.token_used_at : '-'"
                                  class="text-center flex"
                              >
                                <v-icon v-if="solicitation.is_token_used === 1" color="success" small>
                                  fa-check
                                </v-icon>
                                <v-icon v-else color="error" small>
                                  fa-times
                                </v-icon>
                                <div v-if="solicitation.token_used_at">
                                  {{ solicitation.token_used_at | moment("DD/MM/YYYY") }}
                                </div>
                              </td>
                              <td :title="solicitation.publication_moderated_at ? solicitation.publication_moderated_at : '-'" class="text-center flex">
                                <v-icon v-if="solicitation.is_publication_moderated === 1" color="success" small>
                                  fa-check
                                </v-icon>
                                <v-icon v-else color="error" small>
                                  fa-times
                                </v-icon>
                                <div v-if="solicitation.publication_moderated_at">
                                  {{ solicitation.publication_moderated_at | moment("DD/MM/YYYY") }}
                                </div>
                              </td>
                              <td :title="solicitation.need_revalidate === 1 ? solicitation.need_revalidate_at : '-'" class="text-center flex">
                                <div v-if="!solicitation.need_revalidate_at">
                                  <v-icon v-if="solicitation.need_revalidate === 1" color="success" small>
                                    fa-check
                                  </v-icon>
                                  <v-icon v-else color="error" small>
                                    fa-times
                                  </v-icon>
                                </div>
                                <div v-else>
                                  {{ solicitation.need_revalidate_at | moment("DD/MM/YYYY") }}
                                </div>
                              </td>
                              <td :title="solicitation.is_revalidated ? solicitation.revalidated_at : '-'" class="text-center flex">
                                <div v-if="!solicitation.revalidated_at">
                                  <v-icon v-if="solicitation.is_revalidated === 1" color="success" small>
                                    fa-check
                                  </v-icon>
                                  <v-icon v-else color="error" small>
                                    fa-times
                                  </v-icon>
                                </div>
                                <div v-else>
                                  {{ solicitation.revalidated_at | moment("DD/MM/YYYY") }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </div>
                    <v-pagination
                        v-model="solicitations_pagination.current_page"
                        :length="solicitations_pagination.last_page"
                        :total-visible="10"
                        @input="fetchSolicitations"
                        :value="solicitations_pagination.current_page"
                    ></v-pagination>
                  </v-card-text>
                </v-card>
              </WebsiteWrapper>
            </v-col>
          </v-row>
        </template>
      </TabPage>

      <!-- Création d'une invitation manuelle  -->
      <TabPage :menu="menu" :page="page" documentation-path="manager/invitation/email" name="emailing">
        <template #websiteWrapper>
          <WebsiteWrapper
              @selected="invitation.website_id = $event.id;  invitation_selected_website = $event"
              @back="invitation.website_id = 0"
              :verified="2"
              :plan="1"
              mandatory
          ></WebsiteWrapper>
        </template>
        <template #content>
          <v-dialog v-model="urlDialog" max-width="90%">
            <v-card>
              <v-card-title class="headline">
                {{ $t("invitation.dialogs.url.title") }}
              </v-card-title>
              <v-card-text>
                <v-text-field
                    id="emailing_url_id"
                    :value="emailing_url"
                    class="tw-font-bold elevation-12"
                    readonly
                    single-line
                >
                  <template #append>
                    <v-btn :title="$t('common.copyClipBoard')" icon @click="emailingUrlCopyClipBoard">
                      <v-icon color="error" small>fa-copy</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn small text @click="urlDialog = false">
                  {{ $t("common.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <div v-if="invitation.website_id <= 0">
            {{ $t("invitation.emailing.website_not_selected") }}
          </div>
          <template v-else>
            <Form ref="invitation" :callback="requestInvitation">
              <v-stepper non-linear v-model="formstep">
                <v-stepper-header>
                  <v-stepper-step step="1" editable>
                    {{ $t('invitation.emailing.step_type') }}
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2" editable>
                    {{ $t('invitation.emailing.step_order') }}
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="3" editable>
                    {{ $t('invitation.emailing.step_names') }}
                  </v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-row>
                      <v-col cols="4">
                        <v-card id="invitation_what" class="mb-4">
                          <v-col cols="12">
                            <div class="tw-font-semibold">
                              {{ $t("invitation.emailing.title_about") }}
                            </div>
                            <v-select
                                hide-details
                                v-model="invitation.type"
                                :items="types"
                                :label="$t('invitation.emailing.title_about_choice')"
                                col="6"
                                item-text="label"
                                item-value="val"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" v-if="invitation.type==='PRO'||invitation.type==='PRO+SON'">
                            <FormField
                                :props="{ hideDetails: true }"
                                v-model="invitation.product"
                                i18n="invitation.emailing.form.product"
                                input-type="text"
                                rules=""
                            />
                          </v-col>
                          <v-col cols="12" v-if="invitation.type==='SER+SON'||invitation.type==='PRO+SON'||invitation.type==='SON'">
                            <FormField
                                :props="{ hideDetails: true }"
                                v-model="invitation.thematics"
                                i18n="invitation.emailing.form.thematics"
                                input-type="text"
                                rules=""
                            />
                          </v-col>
                          <v-col cols="12">
                            <div class="tw-font-semibold">
                              {{ $t("invitation.emailing.title_external") }}
                            </div>
                            <v-select
                                hide-details
                                v-model="invitation.about_ext_review_url"
                                :items="abouts_ext_review_url"
                                :label="$t('invitation.emailing.title_external_choice')"
                                col="6"
                                item-text="label"
                                item-value="val"
                            ></v-select>
                          </v-col>
                        </v-card>
                      </v-col>
                      <v-col cols="4">
                        <v-card id="invitation_where" class="mb-4">
                          <v-row>
                            <v-col cols="12">
                              <div class="tw-mt-4 tw-font-semibold">
                                {{ $t("invitation.emailing.title_from") }}
                              </div>
                            </v-col>
                          </v-row>
                          <v-row align="end">
                            <v-col cols="12">
                              <v-text-field
                                  hide-details
                                  v-model="invitation.url"
                                  :label="$t('invitation.emailing.form.path')"
                                  type="text"
                                  :prefix="'https://'+invitation_selected_website.host"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="4">
                        <v-card id="invitation_profile" class="mb-4">
                          <v-col cols="12">
                            <div class="tw-font-semibold">
                              {{ $t("invitation.emailing.title_profile") }}
                            </div>
                            <v-select
                                hide-details
                                v-model="invitation.profile_id"
                                :items="profiles"
                                :label="$t('invitation.emailing.profile')"
                                cols="6"
                                item-text="name"
                                item-value="id"
                            ></v-select>
                          </v-col>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                      </v-col>
                      <v-col cols="4">
                        <v-card id="invitation_locale" class="mb-4">
                          <v-col cols="12">
                            <div class="tw-font-semibold">
                              {{ $t("invitation.emailing.title_locale") }}
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                                hide-details
                                v-model="invitation.locale"
                                :items="locales"
                                :label="$t('invitation.emailing.locale')"
                                item-text="localelabel"
                                item-value="locale"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" v-if="websiteHasTemplateMails(invitation_selected_website)">
                            <v-select
                                hide-details
                                v-model="invitation.template_mail"
                                :items="invitation_selected_website.templates.mails"
                                :label="$t('invitation.emailing.form.template_mail')"
                                item-text="label"
                                item-value="key"
                            ></v-select>
                          </v-col>
                        </v-card>
                      </v-col>
                      <v-col cols="4">
                        <v-card id="invitation_mail_delay" class="mb-4">
                          <v-col cols="12">
                            <div class="tw-font-semibold">
                              {{ $t("invitation.emailing.mail_delay") }}
                            </div>
                            <v-text-field
                                :props="{ hideDetails: true }"
                                v-model="invitation.mail_delay_input"
                                :label="$t('invitation.emailing.mail_delay_input')"
                                class="mt-3"
                                max="14"
                                min="0"
                                type="number"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <div class="tw-font-semibold">
                              {{ $t("invitation.emailing.recall_count") }}
                            </div>
                            <v-text-field
                                :props="{ hideDetails: true }"
                                v-model="invitation.recall_count"
                                :label="$t('invitation.emailing.recall_count_input')"
                                class="mt-3"
                                max="14"
                                min="0"
                                type="number"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <div class="tw-font-semibold">
                              {{ $t("invitation.emailing.recall_delay") }}
                            </div>
                            <v-text-field
                                :props="{ hideDetails: true }"
                                v-model="invitation.recall_delay"
                                :label="$t('invitation.emailing.recall_delay_input')"
                                class="mt-3"
                                max="14"
                                min="0"
                                type="number"
                            ></v-text-field>
                          </v-col>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-btn @click="invitationClear" class="float-left">
                          {{ $t("invitation.emailing.bt.clear") }}
                        </v-btn>
                        <v-btn @click="formstep = 2" color="primary" class="float-right mr-12">
                          {{ $t('common.next')}}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <v-row>
                      <v-col cols="12">
                        <v-card id="invitation_order" class="mb-12 pa-5">
                      <h3 class="tw-font-semibold">
                        {{ $t("invitation.emailing.title_order") }}
                      </h3>
                      <v-row id="part_order_date">
                        <v-col cols="12" md="3">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.order_date"
                              i18n="invitation.emailing.order_date"
                              input-type="date"
                              pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.order_number"
                              i18n="invitation.emailing.order_number"
                              input-type="text"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.order_item_code"
                              i18n="invitation.emailing.order_item_code"
                              input-type="text"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.order_item_desc"
                              i18n="invitation.emailing.order_item_desc"
                              input-type="text"
                          />
                        </v-col>
                      </v-row>
                      <v-row id="part_order_item_service" class="mt-0">
                        <v-col cols="12" md="3" class="pt-0">
                          <v-radio-group :label="$t('dashboard.reviewsModeration.response.context.order_item_type')" v-model="invitation.order_item_type" style="padding-left: 30px;">
                            <v-radio value="product" :label="$t('dashboard.reviewsModeration.response.context.order_item_type_product')"></v-radio>
                            <v-radio value="service" :label="$t('dashboard.reviewsModeration.response.context.order_item_type_service')"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <template v-if="invitation.order_item_type==='service'" >
                          <v-col cols="12" md="9" >
                            <v-card>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="6">
                                    <FormField
                                        :props="{ hideDetails: true }"
                                        v-model="invitation.order_service_begin"
                                        i18n="invitation.emailing.order_service_begin"
                                        input-type="date"
                                    />
                                  </v-col>
                                  <v-col cols="6">
                              <FormField
                                  :props="{ hideDetails: true }"
                                  v-model="invitation.order_service_end"
                                  i18n="invitation.emailing.order_service_end"
                                  input-type="date"
                                  :min="invitation.order_service_begin"
                              />
                            </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </template>
                      </v-row>

                      <v-row id="part_gift" class="mt-0">
                        <v-col cols="12" md="3" style="padding-top: 0;">
                          <v-radio-group :label="$t('dashboard.reviewsModeration.response.context.with_gift')" v-model="invitation.with_gift" style="padding-left: 30px;">
                            <v-radio :value="false" :label="$t('dashboard.reviewsModeration.response.context.with_gift_false')"></v-radio>
                            <v-radio :value="true" :label="$t('dashboard.reviewsModeration.response.context.with_gift_true')"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col v-if="invitation.with_gift" cols="12" md="9" style="padding-top: 0;">
                          <v-card>
                            <v-card-text>
                              <v-text-field
                                  :label="$t('dashboard.reviewsModeration.response.context.gift_description')"
                                  v-model="invitation.gift_description"
                                  hide-details="auto"
                              ></v-text-field>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-row id="part_hashtag" class="mt-0">
                        <v-col cols="12" md="3" style="padding-top: 0;">
                          <v-text-field
                              :label="$t('dashboard.reviewsModeration.response.context.hashtag')"
                              v-model="invitation.hashtag"
                              hide-details="auto"
                              :onchange="cleanchashtag()"
                              prepend-inner-icon="small fa-hashtag"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-btn @click="invitationClear" class="float-left">
                          {{ $t("invitation.emailing.bt.clear") }}
                        </v-btn>
                        <v-btn @click="formstep = 3" color="primary" class="float-right mr-12">
                      {{ $t('common.next')}}
                    </v-btn>
                        <v-btn @click="formstep = 1" class="float-right mr-12">
                          {{ $t('common.previous')}}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                  <v-stepper-content step="3">
                    <v-row>
                      <v-col cols="12">
                        <v-card id="invitation_who" class="mb-12 pa-5">
                      <h3 class="tw-font-semibold">
                        {{ $t("invitation.emailing.title_who") }}
                      </h3>
                      <v-row>
                        <v-col cols="12" md="6">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.company_name"
                              i18n="invitation.emailing.form.company_name"
                              input-type="text"
                              rules="required"
                          />
                        </v-col>
                      </v-row>
                      <h3 class="tw-font-semibold mt-12">
                        {{ $t("invitation.emailing.title_customer") }}
                      </h3>
                      <v-row>
                        <v-col cols="12" md="6">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.email"
                              i18n="invitation.emailing.form.email"
                              input-type="email"
                              rules="required|email"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" sm="2">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.customer_gender"
                              i18n="invitation.emailing.form.customer_gender"
                              input-type="text"
                              rules=""
                          />
                        </v-col>
                        <v-col cols="6" sm="4">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.last_name"
                              i18n="invitation.emailing.form.last_name"
                              input-type="text"
                              rules=""
                          />
                        </v-col>
                        <v-col cols="6" sm="4">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.first_name"
                              i18n="invitation.emailing.form.first_name"
                              input-type="text"
                              rules=""
                          />
                        </v-col>
                      </v-row>
                      <h3 class="tw-font-semibold mt-12">
                        {{ $t("invitation.emailing.title_customer_pro") }}
                      </h3>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.customer_bio"
                              i18n="invitation.emailing.form.customer_bio"
                              input-type="text"
                              rules=""
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.customer_link"
                              i18n="invitation.emailing.form.customer_link"
                              input-type="text"
                              rules=""
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <FormField
                              :props="{ hideDetails: true }"
                              v-model="invitation.customer_avatar"
                              i18n="invitation.emailing.form.customer_avatar"
                              input-type="text"
                              rules=""
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-btn @click="invitationClear" class="float-left">
                          {{ $t("invitation.emailing.bt.clear") }}
                        </v-btn>
                        <v-btn @click="$refs.invitation.validate()" color="primary" class="float-right" >
                          {{ $t("invitation.emailing.bt.send") }}
                        </v-btn>
                        <v-btn @click="formstep = 2" class="float-right mr-12">
                          {{ $t('common.previous')}}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </Form>
          </template>
        </template>
      </TabPage>

      <!-- Identification des emails clients Removed 29/10/22 -->
      <TabPage v-if="false" :menu="menu" :page="page" documentation-path="manager/qualify/manual/page" name="manual">
        <template #websiteWrapper>
          <WebsiteWrapper @selected="qualify.website_id = $event.id" :verified="2" :plan="1" mandatory>
          </WebsiteWrapper>
        </template>
        <template #content>
          <Form ref="qualify" :callback="qualifyFormCallback">
            <v-row>
              <v-col cols="12">
                <div class="tw-mt-4 tw-font-semibold">
                  {{ $t("qualify.manual.form.mails") }}
                </div>
                <FormField v-model="qualify.mails"
                           :props="{
                    autoGrow: false,
                    maxLength: 10000,
                    noResize: true,
                    rows: 10,
                  }"
                           :read-only="step === 1"
                           type="VTextarea"
                />
              </v-col>
            </v-row>
          </Form>

          <v-btn v-if="step === 0" @click="qualifyCrypt()"
                 :disabled="qualify.mails.length === 0"
                 class="tw-mt-4"
                 color="primary"
                 small
          >
            {{ $t("qualify.manual.bt.crypt") }}
          </v-btn>
          <v-btn v-if="step === 1" @click="qualifySend()"
                 class="tw-mt-4" color="primary" small >
            {{ $t("qualify.manual.bt.send") }}
          </v-btn>
          <v-btn class="tw-mt-4 tw-ml-4" small @click="qualifyClear">
            {{ $t("qualify.manual.bt.clear") }}
          </v-btn>
        </template>
      </TabPage>

      <!-- Enrichissement d'un fichier client CSV avec le lien d'invitation Removed 29/10/22 -->
      <TabPage v-if="false" :menu="menu" :page="page" documentation-path="manager/invitation/csv" name="csv">
        <template #content>
          <v-dialog v-model="csvDialog" scrollable>
            <v-card>
              <v-card-title class="tw-border-b">
                {{ $t("invitation.csv.dialog.title") }}
              </v-card-title>
              <v-card-text>
                <pre class="tw-mt-4">{{ csvContent }}</pre>
              </v-card-text>
              <v-card-actions class="tw-border-t">
                <v-btn color="primary" small text @click="previousCsv">
                  {{ $t("common.previous") }}
                </v-btn>
                <v-btn color="primary" small text @click="nextCsv">
                  {{ $t("common.next") }}
                </v-btn>
                <v-btn color="primary" small text @click="copyCsvContent">
                  {{ $t("invitation.csv.dialog.copy") }}
                </v-btn>
                <v-btn color="primary" small text @click="downloadCsvContent">
                  {{ $t("invitation.csv.dialog.download") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" small text @click="csvDialog = false">
                  {{ $t("common.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <DragAndDropField
              v-model="files"
              :extensions="extensions"
              :label="$t('invitation.csv.drag_and_drop')"
              :loading="uploading"
              size="40M"
          ></DragAndDropField>

          <div class="tw-mt-4 tw-font-semibold">
            {{ $t("invitation.csv.filters.title") }}
          </div>
          <v-checkbox
              v-model="includeSecuratingAccounts"
              :disabled="true"
              :label="$t('invitation.csv.filters.include_securating_accounts')"
          ></v-checkbox>

          <v-btn
              :disabled="uploading || files.length <= 0"
              class="tw-mt-4 float-right"
              color="primary"
              small
              @click="getCsvFile"
          >
            {{ $t("invitation.csv.convert") }}
          </v-btn>
        </template>
      </TabPage>

    </template>
  </Tab>
</template>
<script>
import tab from "../../../../mixins/tab"
import {Types as TypesSnackbar} from "../../../../store/modules/snackbar"
import WebsiteWrapper from "@/components/common/Form/WebsiteWrapper"
import MD5 from "crypto-js/md5";
import DragAndDropField from "@/components/common/Form/DragAndDropField"
import SolicitationView from "@/components/common/template/SolicitationView";

export default {
  name: "Invitations",
  mixins: [tab],
  components: {
    SolicitationView,
    WebsiteWrapper,
    DragAndDropField,
  },
  data: () => ({
    formstep: 1,
    step: 0,
    qualify: {
      mails: "",
      website_id: 0,
    },
    valid: false,
    pages: ["tracking"],
    page: "tracking",
    menu: "invitation",
    urlDialog: false,
    uploading: false,
    csvDialog: false,
    csvContent: "",
    includeSecuratingAccounts: false,
    send_mail: true,
    files: [],
    formatted_files: [],
    current_formatted_file: 0,
    extensions: ["csv", "txt"],
    locales: [
      {locale: "fr", localelabel: "Français"},
      {locale: "en", localelabel: "Anglais"},
    ],
    invitation_selected_website: null,
    website_templates: null,
    invitation: {
      type: "SER",
      about_ext_review_url: 'NO',
      company_name: "",
      email: "",
      first_name: "",
      last_name: "",
      url: "/",
      send_mail: true,
      last_action_report: "",
      about_product: "",
      about_thematics: "",
      locale: "fr",
      mail_delay: 0,
      website_id: 0,
      profile_id: null,
      order_date: '',
      order_number: '',
      order_item_type: '',
      order_item_code: '',
      order_item_desc: '',
      order_service_begin: '',
      order_service_end: '',
      hashtag: '',
      with_gift: false,
      gift_description: '',
    },
    types: [
      { val: "SER", label: "Avis site" },
      { val: "SER+SON", label: "Avis site et sondage" },
      { val: "PRO", label: "Avis Produit" },
      { val: "PRO+SON", label: "Avis Produit et sondage" },
      { val: "SON", label: "Sondage uniquement" },
    ],
    abouts_ext_review_url: [
      { val: "NO", label: "Uniquement le lien Securating" },
      { val: "ONLY", label: "Uniquement le lien externe" },
      { val: "BOTH", label: "Inclure les deux liens" },
    ],
    profiles: [],
    emailing_url: "",
    snackbar: false,
    snackbarTimeout: 2000,
    snackbarText: "",
    snackbarColor: "success",
    websites: [],
    keywords: '',
    solicitation: null,
    solicitationDialog: false,
    solicitations: [],
    solicitationsWebsites: [],
    selectedSolicitationsWebsite: null,
    selectedSolicitationsWebsiteHost: '',
    solicitations_pagination: {
      current_page: 1,
      last_page: 1,
      pending_count: 0,
      total_count: 0,
    },
  }),
  mounted() {
    this.types = [
      { val: "SER", label: this.$t('invitation.emailing.options_type.ser') },
      { val: "SER+SON", label: this.$t('invitation.emailing.options_type.ser_son') },
      { val: "PRO", label: this.$t('invitation.emailing.options_type.pro') },
      { val: "PRO+SON", label: this.$t('invitation.emailing.options_type.pro_son') },
      { val: "SON", label: this.$t('invitation.emailing.options_type.son') },
    ]
    this.abouts_ext_review_url = [
      { val: "NO", label: this.$t('invitation.emailing.options_external_link.no') },
      { val: "ONLY", label: this.$t('invitation.emailing.options_external_link.only') },
      { val: "BOTH", label: this.$t('invitation.emailing.options_external_link.both') },
    ],
    this.invitation.type = this.types[0].val
    this.reloadPreviousOpenedTab()
    this.fetchProfiles()
  },
  watch: {
    selectedWebsite(value) {
      this.fetchStories(value)
    },
    selectedSolicitationsWebsite() {
      this.fetchSolicitations()
    },
    solicitation(value) {
      if (value !== undefined && value !== null) {
        this.solicitationDialog = true
      } else {
        this.solicitationDialog = false
      }
    },
  },
  methods: {
    WebsiteWrapperChange(websiteObj) {
      console.log('WebsiteWrapperChange(website)',websiteObj);
      this.selectedSolicitationsWebsite = websiteObj.id;
      this.selectedSolicitationsWebsiteHost = websiteObj.host;
    },
    cleanchashtag() {
      if(this.invitation&&this.invitation.hashtag) {
        this.invitation.hashtag = this.invitation.hashtag.toUpperCase()
        this.invitation.hashtag = this.invitation.hashtag.replace(/[^A-Z-]./,'')
        this.invitation.hashtag = this.invitation.hashtag.replace(' ','')
      }
    },
    websiteHasTemplateMails(website) {
      if((website)&&(website.templates)&&(website.templates.mails)){
        return true
      }
    },
    fetchProfiles() {
      this.$axios
          .get("office/manager/profiles/list")
          .then(response => {
            this.profiles = response.data
          })
          .catch(() => this.handleError("profiles.error.fetch_profiles"))
    },
    closeSolicitationDialog() {
      this.solicitationDialog = false
      this.solicitation = null
    },
    deleteSolicitation(solicitation) {
      this.$axios.get(`/office/manager/solicitation/${solicitation.id}/delete`).then(response => {
        let item = response.data
        let foundIndex = this.solicitations.findIndex(x => x.id == item.id);

        this.solicitations.splice(foundIndex,1);
        this.solicitations = [...this.solicitations]
      })
      this.closeSolicitationDialog()
    },
    confirmSolicitation(solicitation,revalidate_type) {
      this.$axios.get(`/office/manager/solicitation/${solicitation.id}/${revalidate_type}/re-confirm`).then(response => {
        let item = response.data
        let foundIndex = this.solicitations.findIndex(x => x.id == item.id);

        this.solicitations[foundIndex] = item;
        this.solicitations = [...this.solicitations]
      })
      this.closeSolicitationDialog()
    },
    cancelSolicitation(solicitation) {
      this.$axios.get(`/office/manager/solicitation/${solicitation.id}/cancel`).then(response => {
        let item = response.data
        let foundIndex = this.solicitations.findIndex(x => x.id == item.id);

        this.solicitations[foundIndex] = item;
        this.solicitations = [...this.solicitations]
      })
      this.closeSolicitationDialog()
    },
    selectSolicitation(solicitation) {
      this.solicitation = solicitation
    },
    fetchSolicitations() {
      this.solicitations = []
      let query = [
        `page=1`,
        `keywords=${encodeURIComponent(this.keywords)}`,
        `website_id=${encodeURIComponent(this.selectedSolicitationsWebsite)}`,
      ].join("&")

      if(this.solicitations_pagination.current_page!==undefined) {
        query = [
          `page=${encodeURIComponent(this.solicitations_pagination.current_page)}`,
          `keywords=${encodeURIComponent(this.keywords)}`,
          `website_id=${encodeURIComponent(this.selectedSolicitationsWebsite)}`,
        ].join("&")
      }

      this.$axios.get(`/office/manager/solicitations/list?${query}`).then(response => {
        this.solicitations = response.data.data
        this.solicitations_pagination = response.data
      })
    },
    invitationClear() {
      this.invitation.email = ""
      this.invitation.first_name = ""
      this.invitation.last_name = ""
      this.invitation.last_action_report = ""
      this.invitation.url = "/"
      this.invitation.about_product = ""
      this.invitation.about_thematics = ""
      this.invitation.locale = "fr"
      this.invitation.mail_delay = 0
      this.invitation.profile_id = null
      this.invitation.order_date = ''
      this.invitation.order_number = ''
      this.invitation.order_item_type = ''
      this.invitation.order_item_code = ''
      this.invitation.order_item_desc = ''
      this.invitation.order_service_begin = ''
      this.invitation.order_service_end = ''
      this.invitation.hashtag = ''
      this.invitation.with_gift = false
      this.invitation.gift_description = ''
      this.formstep = 1
    },
    emailingUrlCopyClipBoard() {
      let testingCodeToCopy = document.querySelector("#emailing_url_id")
      testingCodeToCopy.setAttribute("type", "text") // 不是 hidden 才能複製
      testingCodeToCopy.select()
      document.execCommand("copy")
    },
    requestInvitation() {
      if (!this.invitation.url.startsWith("/")) {
        this.invitation.url = "/" + this.invitation.url
      }

      if (this.invitation.send_mail) {
        return new Promise((resolve, reject) => {
          this.$axios
              .post("/office/manager/invitation/manual", {...this.invitation})
              .then(() => {
                this.snackbarText = this.$t("invitation.emailing.mail.ok")+this.invitation.email
                this.snackbarColor = "success"
                this.invitationClear()
                this.snackbarTimeout = 4 * 1000
                this.snackbar = true
                this.invitation.last_action_report = this.$t("invitation.emailing.mail.ok")+this.invitation.email
                resolve()
              })
              .catch(errors => {
                this.snackbarText = this.$t("invitation.emailing.mail.nok") + " (" + this.invitation.email + ")"
                this.snackbarColor = "error"
                this.snackbarTimeout = 4 * 1000
                this.snackbar = true
                this.invitation.last_action_report = this.$t("invitation.emailing.mail.nok")
                reject(errors.response.data)
              })
        })
      } else {
        return new Promise((resolve, reject) => {
          this.$axios
              .post("/office/manager/invitation/emailing", {...this.invitation})
              .then(response => {
                this.emailing_url = response.data
                this.urlDialog = true
                this.invitation.last_action_report = this.$t("invitation.emailing.get_url.done")
              })
              .catch(errors => {
                this.snackbarText = this.$t("invitation.emailing.url.nok") + "(" + this.invitation.email + ")"
                this.snackbarColor = "error"
                this.snackbarTimeout = 4 * 1000
                this.snackbar = true
                this.invitation.last_action_report = this.$t("invitation.emailing.get_url.error")
                reject(errors.response.data)
              })
        })
      }
    },
    setCurrentCsv(index = 0) {
      if (typeof this.formatted_files[index] !== "undefined") {
        this.csvContent = this.formatted_files[index]
        this.current_formatted_file = index
      } else {
        if (index !== 0) {
          this.setCurrentCsv(0)
        } else {
          this.csvContent = ""
          this.current_formatted_file = 0
        }
      }
    },
    previousCsv() {
      this.setCurrentCsv(this.current_formatted_file - 1)
    },
    nextCsv() {
      this.setCurrentCsv(this.current_formatted_file + 1)
    },
    copyCsvContent() {
      this.$copyText(this.csvContent).then(() => {
        this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
          lines: this.$t("invitation.csv.copied"),
          config: {timeout: 1000 * 4, color: "dark"},
        })
      })
    },
    downloadCsvContent() {
      let element = document.createElement("a")
      element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(this.csvContent))
      element.setAttribute("download", "securating_collect.csv")
      element.click()
    },
    getCsvFile() {
      this.uploading = true
      const formData = this.getFormDataFromFiles()

      formData.append("include_securating_accounts", this.includeSecuratingAccounts)
      formData.append("send_mail", this.send_mail)

      this.$axios
          .post("office/manager/invitation/csv", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(response => {
            this.formatted_files = response.data.data

            this.setCurrentCsv()

            this.csvDialog = true
          })
          .catch(() => {
            this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
              lines: this.$t("invitation.csv.upload_error"),
              config: {timeout: 1000 * 6, color: "error"},
            })
          })
          .finally(() => {
            this.uploading = false
          })
    },
    getFormDataFromFiles() {
      let formData = new FormData()
      this.files.forEach((f, x) => {
        formData.append("file" + (x + 1), f)
      })
      return formData
    },
    qualifyFormCallback() {},
    qualifyClear() {
      this.qualify.mails = ""
      this.step = 0
    },
    qualifyCrypt() {
      let mailsArr = this.qualify.mails.split("\n")
      let cryptMails = ""
      let notCryptMails = ""
      let mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      if (mailsArr.length) {
        mailsArr.forEach(function(mail) {
          if (mail.trim() !== "") {
            if (mail.match(mailformat)) {
              cryptMails += MD5(mail).toString() + "\n"
            } else {
              notCryptMails += mail + "\n"
            }
          }
        })
        if (notCryptMails === "") {
          this.qualify.mails = cryptMails
          this.snackbarText = this.$t("qualify.manual.messages.cryptDone")
          this.snackbarColor = "success"
          this.snackbarTimeout = 4 * 1000
          this.snackbar = true
          this.step = 1
        } else {
          this.qualify.mails = notCryptMails
          this.snackbarText = this.$t("qualify.manual.messages.cryptNotDone")
          this.snackbarColor = "warning"
          this.snackbarTimeout = 4 * 1000
          this.snackbar = true
        }
      }
    },
    qualifySend() {
      this.$axios
          .post("/office/manager/qualify/usersByMD5Mails", {
            website_id: this.qualify.website_id,
            md5mails: this.qualify.mails,
          })
          .then(response => {
            this.snackbarText = this.$t("qualify.manual.messages.sendDoneMorePublication").replace("%d", response.data.newPublication)
            this.snackbarColor = "warning"
            if (response.data.newPublication === 1) {
              this.snackbarColor = "success"
              this.snackbarText = this.$t("qualify.manual.messages.sendDoneOnePublication")
            }
            if (response.data.newPublication > 1) {
              this.snackbarColor = "success"
              this.snackbarText = this.$t("qualify.manual.messages.sendDoneMorePublication")
            }
            this.snackbarTimeout = 6 * 1000
            this.snackbar = true
          })
          .catch(() => {
            this.snackbarText = this.$t("qualify.manual.messages.sendDoneError")
            this.snackbarColor = "warning"
            this.snackbarTimeout = 4 * 1000
            this.snackbar = true
          })
    },
  },
}
</script>
